import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/App'
import './index.css'
import { initSentry } from '@/config/sentry.config'
import { QueryProvider } from './providers/QueryProvider'

// Initialize Sentry before React
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </StrictMode>
)
